import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-6 ml-4" }
const _hoisted_2 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "flex gap-y-3 flex-row flex-wrap"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold flex flex-row items-center w-full text-black-lp-300" }, " Virtual Account ", -1)
const _hoisted_5 = { class: "w-1/2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, { label: "Informasi Bank" }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        class: "w-6/12",
        label: _ctx.$t('partnerManagement.accountName'),
        value: _ctx.beneficiaryDetail[0]?.bankAccountName
      }, null, 8, ["label", "value"]),
      _createVNode(_component_DataWrapper, {
        class: "w-6/12",
        label: _ctx.$t('partnerManagement.bank'),
        value: _ctx.beneficiaryDetail[0]?.bankName
      }, null, 8, ["label", "value"]),
      _createVNode(_component_DataWrapper, {
        class: "w-6/12",
        label: _ctx.$t('partnerManagement.accNo'),
        value: _ctx.beneficiaryDetail[0]?.bankAccountNumber
      }, null, 8, ["label", "value"]),
      _createVNode(_component_DataWrapper, {
        class: "w-6/12",
        label: "Email",
        value: _ctx.beneficiaryDetail[0]?.bankAccountEmail
      }, null, 8, ["value"])
    ]),
    (_ctx.partnerType === 'pos')
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.vaNumbers, (vaNumber, index) => {
            return (_openBlock(), _createBlock("div", {
              key: `${index}`,
              class: "flex w-full items-center"
            }, [
              _createVNode("div", _hoisted_5, [
                _createVNode("img", {
                  src: vaNumber.bankAccountBankLogo,
                  style: {"max-height":"27px"},
                  alt: "bank"
                }, null, 8, ["src"])
              ]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: vaNumber.bankAccountLabel,
                value: vaNumber.bankAccountAccountNumber
              }, null, 8, ["label", "value"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}